import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const headers = { 'Content-Type': 'application/json' };

const handle = (err) => {
    if (err.response?.data) throw err.response.data;
    throw err;
};

// GET the queue of pending "next receipt" Multi MRR tasks for this user — rows come from the
// MultiMRRCount table (already-approved PO whose IsSingleMRR=0, chained to a previous MRR that's
// still Open i.e. not fully received yet).
export const getTransferRecieptMultiGridDetails = async (Roleid, UID) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/GetTransferRecieptMultiGridDetails?Roleid=${encodeURIComponent(Roleid)}&UID=${encodeURIComponent(UID)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// GET the item-level detail grid for one pending Multi MRR receipt task.
export const getGridTransferRecieptMultiData = async (Mrrno, Pono, Potype) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/GridTransferRecieptMultiData?Mrrno=${encodeURIComponent(Mrrno)}&Pono=${encodeURIComponent(Pono)}&Potype=${encodeURIComponent(Potype || '')}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// PUT — submit the next partial/follow-up receipt against the PO
// payload: { Rid, ItemCodes, RecievedQty, Basic, SumRecievedQty, SumRaisedQty, Date, Remarks,
//            PoNo, OldMrrno, CreatedBy, Roleid, Filechk, Extension }
export const saveVendorTransferRecieptMulti = async (payload) => {
    try {
        const res = await axios.put(
            `${API_BASE_URL}/Purchase/SaveVendorTransferRecieptMulti`,
            payload,
            { headers, timeout: 30000 }
        );
        return res.data;
    } catch (err) { handle(err); }
};
